import { privateInstance } from 'services/axios/privateInstance'
import {
  API_GET_KB_ARTICLES,
  API_GET_KB_ARTICLE,
  API_SEARCH_KB_ARTICLES,
  API_GET_KB_SECTIONS,
  API_CREATE_KB_ARTICLE,
  API_UPDATE_KB_ARTICLE,
  API_DELETE_KB_ARTICLE,
  API_UPLOAD_KB_IMAGE,
} from 'constants/apiUrl'
import {
  IArticleDetailed,
  IArticleForm,
  IArticleListItem,
  IArticleRequest,
  IArticleSearchResult,
  ISection,
} from 'typescript/interfaces/knowledgeBase'
import { AxiosResponse } from 'axios'
import { generatePath } from 'react-router-dom'
import { storageInstance } from 'services/axios/storageInstance'
import { getDownloadUrl, uploadToS3 } from 'services/storage'

export const getArticles = (params: IArticleRequest) =>
  privateInstance.get<IArticleRequest, AxiosResponse<Array<IArticleListItem>>>(API_GET_KB_ARTICLES, { params })

export const searchArticles = (search: string) =>
  privateInstance.get<string, AxiosResponse<Array<IArticleSearchResult>>>(API_SEARCH_KB_ARTICLES, { params: { search } })

export const getArticle = (id: number) =>
  privateInstance.get<number, AxiosResponse<IArticleDetailed>>(generatePath(API_GET_KB_ARTICLE, { id }))

export const getSections = () => privateInstance.get<void, AxiosResponse<Array<ISection>>>(API_GET_KB_SECTIONS)

export const createArticle = (values: IArticleForm) =>
  privateInstance.post<IArticleForm, AxiosResponse<IArticleDetailed>>(API_CREATE_KB_ARTICLE, values)

export const updateArticle = ({ id, values }: { id: number; values: IArticleForm }) =>
  privateInstance.put<IArticleForm, AxiosResponse<IArticleDetailed>>(generatePath(API_UPDATE_KB_ARTICLE, { id }), values)

export const deleteArticle = (id: number) =>
  privateInstance.delete<number, AxiosResponse<boolean>>(generatePath(API_DELETE_KB_ARTICLE, { id }))

export const uploadArticleImage = async (file: File) => {
  const uploadUrl = await getDownloadUrl({
    DocumentName: file.name,
    DocumentDestination: 'KnowledgeBase',
    DestinationObjectId: 0,
  })
  await uploadToS3(file, uploadUrl.data)
  const tempUrl = uploadUrl.data.split('?')[0]
  const publicUrl = await storageInstance.post<{ fileUrl: string }, AxiosResponse<string>>(API_UPLOAD_KB_IMAGE, { fileUrl: tempUrl })
  return publicUrl.data
}
